export default __webpack_public_path__ + "static/media/clock.b1587b01.svg";